import {useMemo, useState} from 'react';
import {useDebounce} from '@netx/core-components/hooks/useDebounce';

export type UseFilterItemsParams<T = unknown> = {
	items: T[];
	filterFn: (filterStr: string, items: T[]) => T[];
};

/**
 * Client side filtering of an array of items
 */
export const useFilterItems = <T = unknown>({
	items,
	filterFn,
}: UseFilterItemsParams<T>) => {
	const [filter, setFilter] = useState('');
	const [debouncedFilter] = useDebounce(filter, 250);

	const filtered = useMemo(() => {
		if (filter == null || filter === '') {
			return {
				filteredItems: items,
				filtered: false,
			};
		}

		const normalizedFilter = filter.toLowerCase();
		return {
			filteredItems: filterFn(normalizedFilter, items),
			filtered: true,
		};
	}, [debouncedFilter, filterFn, items]);

	return {
		...filtered,
		filter,
		setFilter,
	};
};

export default useFilterItems;
